const Workercode = () => {
    // eslint-disable-next-line no-undef
    self.onmessage = event => {
        // eslint-disable-next-line no-undef
        fetch(`${event.data.baseUrl}/api/tables/usage-data/`, {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            keepalive: true,
            headers: {
                'Content-Type': 'application/json',
                Authorization: event.data.token
            },
            body: JSON.stringify({
                app_id: event.data.app_id,
                city_id: event.data.city_id,
                event_id: event.data.event_id
            })
        }).then(response => {
            if (response.status === 400) {
                console.log('Request failed to log user usage::', response.statusText);
            } else if (response.status === 429) {
                console.log('Request was throttled.Expected to be available in few seconds');
            } else if (response.status === 201) {
                console.log('Successfully logs user usage');
            }
        });
    };
};

let code = Workercode.toString();

code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const BLOB = new Blob([code], { type: 'application/javascript' });
const WORKER_SCRIPT = URL.createObjectURL(BLOB);

module.exports = WORKER_SCRIPT;
